import { MNSproCloudApi } from '..';
import { Changelog, ChangelogSource } from '../api/v2';

export class ChangelogsService {
  /**(🔒: Announcements.WriteAll, Announcements.ShowModule)
   *
   * Any of the following permissions are required:
   * - Announcements.WriteAll
   * - Announcements.ShowModule</li></ul>
   *
   * Gets all available release note with the provided
   * changelog source.
   *
   * @static
   * @param {string} authToken
   * @param {ChangelogSource} source
   * @return {*}  {Promise<Changelog>}
   * @memberof ChangelogsService
   */
  static async get(
    authToken: string,
    source: ChangelogSource,
  ): Promise<Changelog> {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.ChangelogApiFactory(config);

    const r = await api.getUpdates(source);
    return r.data;
  }
}
